<div class="graph-section-v4__chart-container">
  <canvas #chartCanvas id="rcc-chart" class="graph-section-v4__canvas"></canvas>
</div>

<div class="graph-section-v4__mobile-tooltip" *ngIf="isMobile && mobileTooltip">
  <div class="graph-section-v4__mobile-tooltip-header" [style.background]="mobileTooltip.headerColor" [style.color]="mobileTooltip.headerTextColor">
    {{ mobileTooltip.headerText }}
  </div>
  <div class="graph-section-v4__mobile-tooltip-body" [class.values-equal]="mobileTooltip.valuesEqual">
    <div class="graph-section-v4__mobile-tooltip-body-rows">
      <ng-container *ngIf="mobileTooltip.withConvOnTop; else undesirableRows">
        <p class="graph-section-v4__mobile-tooltip-favorable-conversion graph-section-v4__mobile-tooltip-with-conv graph-section-v4__mobile-tooltip-dot-teal">
          <strong>{{ mobileTooltip.withConvValue }}</strong> {{ mobileTooltip.withConvLabel }}
        </p>
        <p class="graph-section-v4__mobile-tooltip-unfavorable-conversion graph-section-v4__mobile-tooltip-dot-yellow">
          <strong>{{ mobileTooltip.withoutConvValue }}</strong> {{ mobileTooltip.withoutConvLabel }}
        </p>
      </ng-container>
      <ng-template #undesirableRows>
        <p class="graph-section-v4__mobile-tooltip-favorable-conversion graph-section-v4__mobile-tooltip-dot-yellow">
          <strong>{{ mobileTooltip.withoutConvValue }}</strong> {{ mobileTooltip.withoutConvLabel }}
        </p>
        <p class="graph-section-v4__mobile-tooltip-unfavorable-conversion graph-section-v4__mobile-tooltip-with-conv graph-section-v4__mobile-tooltip-dot-teal">
          <strong>{{ mobileTooltip.withConvValue }}</strong> {{ mobileTooltip.withConvLabel }}
        </p>
      </ng-template>
    </div>
  </div>
  <div class="graph-section-v4__mobile-tooltip-betr">
    <img src="assets/images/BETR-Icon-Chart.svg" class="graph-section-v4__mobile-tooltip-betr-icon" alt="" />
    <span>{{ mobileTooltip.betrLabel }} <strong>{{ mobileTooltip.betrValue }}</strong></span>
  </div>
  <div class="graph-section-v4__mobile-tooltip-future-tax">
    {{ mobileTooltip.futureTaxLabel }} <strong>{{ mobileTooltip.futureTaxValue }}</strong>
  </div>
</div>

<div
  *ngIf="hasProfitabilityPoint || showIraNote"
  class="graph-section-v4__below-chart"
>
  <div
    *ngIf="hasProfitabilityPoint"
    class="graph-section-v4__profitability-callout"
  >
    <div class="graph-section-v4__profitability-marker">
      <img
        class="graph-section-v4__profitability-icon"
        src="assets/svgs/Vector.svg"
        alt=""
        aria-hidden="true"
      />
      <div class="graph-section-v4__profitability-copy">
        <div class="graph-section-v4__profitability-title text-body-2 weight-bold">{{ profitabilityLegendTitle }}</div>
      </div>
    </div>

    <p class="graph-section-v4__profitability-description text-body-3">{{ profitabilityLegendDescription }}</p>
  </div>

  <div
    *ngIf="showIraNote"
    class="graph-section-v4__please-note"
  >
    <div class="graph-section-v4__please-note-marker">
      <ngx-axs-icon
        class="graph-section-v4__please-note-icon"
        axsType="infoSolid"
        axsAriaLabel="information"
        [axsWidth]="16"
      ></ngx-axs-icon>
      <div class="graph-section-v4__please-note-title text-body-2 weight-bold">{{ iraNoteTitle }}</div>
    </div>
    <p class="graph-section-v4__please-note-description text-body-3">
      {{ iraNoteBody }}
      <button type="button" class="graph-section-v4__please-note-discover" (click)="openDiscoverModal()">{{ iraNoteDiscoverText }}</button>
      {{ iraNoteDesc }}
    </p>
  </div>
</div>

<discover-modal *ngIf="isDiscoverModalOpen" [(isOpen)]="isDiscoverModalOpen"></discover-modal>
